import React from "react";
import {Link} from "gatsby";
import tags from "../../../data/tags";

export default function Tag({post}) {

  if (post.tags === null) {
    return "";
  } 
    return (
      <div className="post-z-c1-tag">
        {post.tags.map((tag) => {
                  let tagTitle;
                  if (tags[tag] === undefined) {
                    tagTitle = "";
                  } else {
                    tagTitle = tags[tag].title;
                  }
                  return (
                    <Link
                      to={`/tag/${tag}/`}
                      key={tag}
                      className="post-z-c1-tag-link"
                    >
                      {tagTitle}
                    </Link>
                  );
                })}
      </div>
        );
}